import { styled } from 'styled-components';

const Label = styled.label`
	color: ${(props) => props.theme.palette.text.label};
	font-size: 0.7rem;
`;

export default Label;
